import stepperDefaultFunctions from "./default";
import stepperReschedulingFunctions from "./rescheduling";

export const routes = {
    default: stepperDefaultFunctions,
    rescheduling: stepperReschedulingFunctions
};